import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { useIsQuestionnaireReadOnly } from '../../common/hooks';

import type { RootState } from '../../../../store';

export default function useIsOnboardingQuestionnaireReadOnly() {
  const details = useSelector(
    (state: RootState) => state.onboardingQuestionnaire.onboardingQuestionnaireDetails,
  );
  const { onboardingQuestionnaireId } = useParams<'onboardingQuestionnaireId'>();

  return useIsQuestionnaireReadOnly(details, onboardingQuestionnaireId);
}
